










































import { BButton } from 'bootstrap-vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'Navbar',
    components: {
        'b-button': BButton,
    },
})
export default class Navbar extends Vue {
    collapsed = false;
}
